<template>

  <!-- xin -->
  <div class="loginBox">
    <div id="buttonContainer">
      <button id="backToTopBtn">
        <img src="../../public/assets/images/flow/it_fuwu.png" @click="getItfuwu" alt="Back to Top" style="width: 50px; height: 50px;">
      </button>
      <div id="toggleBtn" @click="changeBtn()">
        <img src="../../public/assets/images/flow/it_down.png" id="suofang" alt="Toggle Button" style="width: 20px; height: 20px;">
      </div>
    </div>
    <div class="titleBox">
      <img class="w-title1" src="../assets/images/newLogo.png" alt="" style="">
      <img class="w-title2" src="../assets/images/h-logo2-icon-index.png" alt="" style="">
    </div>
    <!-- 内容部分 -->
    <div class="content clearfix" :style="{ height: screenHeight + 'px' }">
      <!-- 左侧 -->
      <div class="left-content">

        <div class="login_header">
          <span @click="cur=0" :class="{active:cur==0}">供应商用户登录</span>
          <span @click="login(2,'ruleForm')" :class="{active:cur==1}">集团统一登录</span>
          <!-- <span @click="cur=2" :class="{active:cur==2}">扫码登录</span> -->
        </div>
        <div class="logins" v-show="cur==0" @keyup.enter="login(0,'ruleForm')">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="input user">
            <el-form-item label="" prop="phone" class="box">
              <img src="../assets/images/user-13.png" alt="" style="width: 24px;height: auto;margin-left: 10px;">
              <el-input class="phone" v-model="ruleForm.phone" autocomplete="off" clearable placeholder="输入用户名"></el-input>
            </el-form-item>
            <el-form-item label="" prop="password" class="box">
              <img src="../assets/images/pwd-13.png" alt="" style="width: 24px;height: auto;margin-left: 10px;">
              <el-input class="password" type="password" v-model="ruleForm.password" clearable placeholder="输入密码"></el-input>
            </el-form-item>
            <el-form-item label="" prop="validCode" class="box">
              <!-- <img src="../assets/images/yzm.png" alt="" style="width: 24px;height: auto;margin-left: 10px;">-->
              <div>
                <img :src="codeUrl" @click="getCode" style="width: 94px;height: auto;margin-left: 190px;" />
              </div>
              <el-input class="phone" v-model="ruleForm.validCode" clearable placeholder="输入验证码">
              </el-input>
            </el-form-item>

            <!-- <div class="d1440">
                                    <slide-verify :l="22"
                                        :r="8"
                                        :w="380"
                                        :h="80"
                                        @success="onSuccess"
                                        @fail="onFail"
                                        @refresh="onRefresh"
                                        :slider-text="text"
                                    ></slide-verify>
                                </div>
                                <div class="d1920">
                                    <slide-verify :l="32"
                                        :r="10"
                                        :w="506"
                                        :h="100"
                                        @success="onSuccess"
                                        @fail="onFail"
                                        @refresh="onRefresh"
                                        :slider-text="text"
                                    ></slide-verify>
                                </div>
                                 -->

          </el-form>
            <div class="checkBox">
                <el-checkbox v-model="flagzh" @change="selfUnlock" label="记住账号"></el-checkbox>
            </div>
          <div class="forget">

            <div class="wang">
              <div class="shensu" style="margin-left:20px;" @click="shensu">账号申诉</div>
              <div class="shensu" style="margin-left:20px;" @click="wangji">忘记密码</div>
                <div class="shensu" style="margin-left:20px;" @click="goIam">经销商重置密码</div>
            </div>

          </div>
          <div class="dengluSign">
            <div class="denglu" :class="{'active':index==indx}" v-for="(item,index) in list" :key="index" @click="login(index,'ruleForm')">{{item}}
            </div>
          </div>

          <div class="dengluSign">
             <div class="desc">
                 <span style="color: red;"> 注意：86，87，88码经销商账号已对接集团统一登录，请先点击"经销商重置密码"重置密码，后续使用集团统一登录端口登录</span>
             </div>
          </div>

        </div>
      </div>
      <div class="right-content" :style="{ height: screenHeight + 'px' }">
        <div class="recommendPage" :style="{ height: screenHeight + 'px' }">
          <swiper :options="swiperOption" ref="mySwiper">
            <swiper-slide>
              <img src="../assets/images/1.svg" alt="" style="">
            </swiper-slide>
            <swiper-slide><img src="../assets/images/2.svg" alt="" style=""></swiper-slide>
            <swiper-slide><img src="../assets/images/3.svg" alt="" style=""></swiper-slide>
            <swiper-slide><img src="../assets/images/4.svg" alt="" style=""></swiper-slide>
            <swiper-slide><img src="../assets/images/5.svg" alt="" style=""></swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
            <!-- <div class="swiper-button-prev" slot="button-prev"></div>
                    <div class="swiper-button-next" slot="button-next"></div> -->
          </swiper>
        </div>
      </div>
    </div>
    <div class="h-headLink ljj_yunwei">
      运维工程师：周瞳
      <span style="margin-left: 0.3rem;">手机号：15866863942 </span>
      <span style="margin-left: 0.3rem;">邮箱：yuanhangyl@yuanh.com.cn</span>
      <span style="margin-left: 0.3rem;">
        <brupload refid="2023112409ed630e" reftype="隐私政策" :tpFlag='true' :showtime="false">
        </brupload>

      </span>
    </div>
    <div v-if="agreeIs" class="agreeBox">
      <div class="agree">
        <div class="agreeTop">
          <div class="title">用户协议</div>
          <div class="desc">
            遵守中华人民共和国相关法律法规，包括但不限于《中华人民共和国计算机信息系统安全保护条例》、《计算机软件保护条例》、《最高人民法院关于审理涉及计算机网络著作权纠纷案件适用法律若干问题的解释(法释[2004]1号)》、《全国人大常委会关于维护互联网安全的决定》、《互联网电子公告服务管理规定》、《互联网新闻信息服务管理规定》、《互联网著作权行政保护办法》和《信息网络传播权保护条例》等有关计算机互联网规定和知识产权的法律和法规、实施办法。<br />
            用户对其自行发表、上传或传送的内容负全部责任，所有用户不得在本站任何页面发布、转载、传送含有下列内容之一的信息，否则本站有权自行处理并不通知用户：(1)违反宪法确定的基本原则的； <br />
            (2)危害国家安全，泄漏国家机密，颠覆国家政权，破坏国家统一的； <br />(3)损害国家荣誉和利益的； <br />(4)煽动民族仇恨、民族歧视，破坏民族团结的； <br />
            (5)破坏国家宗教政策，宣扬邪教和封建迷信的； <br />(6)散布谣言，扰乱社会秩序，破坏社会稳定的；<br />(7)散布淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的； <br />
            (8)侮辱或者诽谤他人，侵害他人合法权益的； <br />(9)煽动非法集会、结社、游行、示威、聚众扰乱社会秩序的； <br />(10)以非法民间组织名义活动的；<br />
            (11)含有法律、行政法规禁止的其他内容的。
          </div>
          <div class="agreeContinue" @click="agrees">同意并继续</div>
        </div>
        <div class="agreeBottom" @click="agrees">
          <img src="../assets/images/chas.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>
    <script>
import ss from '../api/SystemService'
import store from "../store";
import SlideVerify from '../components/vue-slide-verify.vue';
//
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import axios from "axios";
let Base64 = require('js-base64').Base64;
export default {
  data () {
    return {
      cur: 0, //默认选中第一个tab
      flagzh: true,
      flag: false,
      agreeIs: false,
      indx: 0,
      codeUrl: "",
      ruleForm: {
        phone: null,
        password: '',
        uuid: "",
        validCode: "",
        // yzm: '1234'
      },
      msg: '',
      text: '>>>请拖动滑块完成拼图>>>',
      checked: true,
      rules: {
        phone: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        validCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ],
      },
      list: ["登录", "注册"],
      swiperOption: {
        loop: true,
        autoplay: {
          delay: 5000,
          speed: 5000,//匀速时间
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true //允许分页点击跳转
        },
        // 设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      screenHeight: document.body.clientHeight * 0.8
    }
  },
  computed: {
    swiper () {
      return this.$refs.mySwiper.swiper;
    }
  },
  mounted () {
    if (this.flagzh) {
      if (localStorage.getItem("userId") != 'null') {
        this.ruleForm.phone = localStorage.getItem("userId");
        console.log(this.ruleForm.phone)
      } else {
        console.log(this.ruleForm.phone, "///////////")
      }
    }
    console.log("this is current swiper instance object", this.swiper);
    const that = this
    window.onresize = () => {
      return (() => {
        window.screenHeight = document.body.clientHeight
        that.screenHeight = window.screenHeight
      })()
    }
  },
  created () {
    this.getCode();
    this.getUrlCode();
  },
  methods: {
    //记住账号
    selfUnlock () {
      console.log(this.ruleForm.phone)
      let _this = this;
      if (_this.flagzh) {
        if (_this.ruleForm.phone) {
          localStorage.setItem("userId", _this.ruleForm.phone);
        }
      } else {
        localStorage.setItem("userId", null);
      }
    },
    getphonecode () {
      ss.LoginService.getphonecode(this.ruleForm.phone).then(rd => {
        // console.log(rd);
        this.$msg.msgs(rd.message)
      })
    },

    login (index, ruleForm) {
      if (this.flagzh) {
        localStorage.setItem("userId", this.ruleForm.phone);
      }
      localStorage.setItem("userName", this.ruleForm.phone);
      this.indx = index;
      this.msg = 'login success'
      this.flag = true;
      if (this.indx == 0) {
        this.$refs[ruleForm].validate((valid) => {
          //对登录信息进行base64加密
          let base64LoginInfo = Base64.encode(JSON.stringify(this.ruleForm));

          if (valid) {
            ss.LoginService.login(base64LoginInfo).then(rd => {
              if (!rd.f) {
                this.getCode();
                this.$msg.msge(rd.msg);
              }

              console.log(rd)
              if (rd.msg == "密码超两个月未重置，请重置密码后再进行登陆！") {
                this.$confirm('密码超两个月未重置，请重置密码后再进行登陆！', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                  // 跳转密码重置页面
                  this.$router.push({ path: "/resetPassPage", query: { user: this.ruleForm.phone } });
                  return;
                }).catch(() => {
                  this.$message({
                    type: 'info',
                    message: '已取消重置'
                  });
                  return;
                });
                return;
              }
              // 陈冠赤添加开始
              if (rd.msg == "该账号是首次登陆，请先修改密码，上传必要资质！") {
                this.$confirm('该账号是首次登陆，请先修改密码，上传必要资质', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                  // 跳转首次登陆配置页面
                  this.$router.push({ path: "/firstlogin", query: { user: this.ruleForm.phone } });
                  return;
                }).catch(() => {
                  this.$message({
                    type: 'info',
                    message: '已取消设置'
                  });
                  return;
                });
                return;
              }
              // 陈冠赤添加结束


              // 陈冠赤添加
              if (rd.obj.isActive == 0) {
                this.$confirm('该账号暂未激活，请填写详细信息，审核通过后进行激活，否则无法使用', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                  store.commit("setUser", rd)
                  // 跳转首次登陆配置页面
                  this.$router.push("/personal/userin?usercode=" + rd.obj.usercode);
                }).catch(() => {
                  this.$message({
                    type: 'info',
                    message: '已取消设置'
                  });
                  this.$router.push("/login");
                });

              } else {
                store.commit("setUser", rd)

                //设置展示通知本地缓存参数
                let obj = {
                  showNotify: true,  //是否有效
                  time: Date.now(),    //当前时间
                  expire: 12          //有效时间 12小时
                };

                let val = localStorage.getItem("showNotifyMain");
                val = JSON.parse(val);
                console.log(val, "缓存login");
                if (val != null) {
                  //判断是否超时 如果超时生成缓存

                  if (Date.now() / 1000 / 60 / 60 - val.time / 1000 / 60 / 60 > val.expire) {
                    //localStorage 设置的值不能为对象,转为json字符串
                    localStorage.setItem("showNotifyMain", JSON.stringify(obj));
                  }
                } else {
                  //localStorage 设置的值不能为对象,转为json字符串
                  localStorage.setItem("showNotifyMain", JSON.stringify(obj));
                }

                this.$router.push({ path: rd.obj.defaultpage });

                //设置经销商文件到期提醒
                let objAgent = {
                  showNotify: true,  //是否有效
                };
                let valAgent = localStorage.getItem("showNotifyAgent");
                localStorage.setItem("showNotifyAgent", JSON.stringify(obj));
              }


              // if(rd.obj.roles && rd.obj.roles.length>0){
              //     if (rd.obj.roles[0].name==='小微主'){
              //         this.$router.push({path: '/secondPage'});
              //     }else{
              //         this.$router.push({
              //             path: '/'
              //         });
              //     }
              // }else{
              //     this.$router.push({
              //         path: '/'
              //     });
              // }
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });

      } else if (this.indx == 2) {
        ss.LoginService.getIPAndUrlAim().then(rd => {
          axios.get(rd + "").then(json => {
            window.location.href = rd
          });
        })
      }
      else {
        this.$router.push({ path: '/sign', query: '0' });
      }

    },
    agrees () {
      this.agreeIs = false;
    },
    onSuccess () {
      this.msg = 'login success'
      this.flag = true;
    },
    onFail () {
      this.msg = ''
      this.flag = false;
    },
    onRefresh () {
      this.msg = ''
    },
    shensu () {
      this.$router.push("/account_complaint");

    },
    // shensu() {
    //     this.$confirm('账号申诉只能外部用户使用', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //     }).then((v) => {
    //     console.log(v,"///////////")
    //     this.$message({
    //         type: 'success',
    //         message: '删除成功!',
    //         url: this.$router.push("/account_complaint")
    //     });
    //     }).catch((v) => {
    //     console.log(v,"///////////")
    //     this.$message({
    //         type: 'info',
    //         message:  this.$router.go(-1)
    //     });
    //     });
    // },
    wangji () {
      this.$router.push("/resetPass");
    },
   goIam(){

        if(process.env.VUE_APP_AJAXURL.indexOf('oms.haierbiomedical.com')!=-1){
            window.location.href = 'https://iama.haier.net/terminal/?show-register-reset=true&client_id=e07bcdfab42df405191f51ac3d4ea3c6&source=https%3A%2F%2Fiama.haier.net%2F%23login#resetAccount';
        }else{
            window.location.href = 'https://iam-test.haier.net/terminal/?show-register-reset=true&client_id=06995feefba7f2aa5f1a8fc0f5cf372b&source=https%3A%2F%2Fiam-test.haier.net%2F%23login#resetAccount';
        }
      },

    getCode () {
      ss.LoginService.getCodeImg().then(rd => {
        this.codeUrl = "data:image/gif;base64," + rd.img;
        this.ruleForm.uuid = rd.uuid;
      })
    },
    getUrlCode () {
      console.log("getUrlCodesssaaa", window.location.href)
      var url = window.location.href;      //获取当前url
      //判断url是否携带参数
      if (url.indexOf('?') != -1) {
        var dz_url = url.split('#')[0];        //获取#/之前的字符串
        var cs = dz_url.split('?')[1];        //获取?之后的参数字符串
        var cs_arr = cs.split('&');          //参数字符串分割为数组
        var cs = {};
        for (var i = 0; i < cs_arr.length; i++) {    //遍历数组，拿到json对象
          cs[cs_arr[i].split('=')[0]] = cs_arr[i].split('=')[1]
        }
        console.log(cs);
        var code = cs.code;
        var state = cs.state;
        if (state == undefined) {
          state = null;
        }

        if (null != code) {
          ss.LoginService.getSsoLogin(code, state).then(rd => {
            if (rd.f == true) {
              if (rd.obj.f == false) {
                this.$msg.msge("统一认证失败,请重新登录!")
              } else {
                store.commit("setUser", rd)
                this.loading = false;
                this.$router.push({ path: rd.obj.defaultpage });
              }
            }
          })
        }
      }


    },
    getItfuwu () {
      var userid = this._user.usercode
      ss.LoginService.getItPt(userid).then(rd => {
        window.open(rd, '_blank')
      })
    },
    changeBtn () {
      var btn = document.getElementById("backToTopBtn");
      if (btn.style.display === "none") {
        btn.style.display = "block";
      } else {
        btn.style.display = "none";
      }
      var suofang = document.getElementById("suofang");
      if (btn.style.display === "none") {
        suofang.src = require("../../public/assets/images/flow/it_up.png");
      } else {
        suofang.src = require("../../public/assets/images/flow/it_down.png");
      }
    }
  },
  components: {
    SlideVerify,
    swiper,
    swiperSlide
  }
}
    </script>

    <style>
.user input::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #fff;
}

.clearfix:after {
  content: '020';
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.clearfix {
  /* 触发 hasLayout */
  zoom: 1;
}
.content {
  width: 80%;
  height: 80vh;
  min-height: 500px;
  margin: 0 auto;
  background: none;
  padding: 0;
  position: fixed;
  top: 10vh;
  left: 10vw;
  border-radius: 10px;
  overflow: hidden;
}
.left-content {
  float: right;
  width: 30%;
}
.left-content .title {
  margin: 0 auto;
  margin-top: 60px;
  margin-bottom: 30px;
  text-align: center;
  font-size: 32px;
  color: #707070;
  /* color: #128bf1; */
}
.right-content {
  float: left;
  width: 65%;
  margin-top: 12px;
}
.recommendPage .swiper-container {
  position: relative;
  width: 100%;
  height: 100%;
}
.recommendPage .swiper-container .swiper-slide {
  width: 100%;
  line-height: 100%;
  /* background: yellowgreen;
            color: #000;
            font-size: 16px;
            text-align: center; */
}
.recommendPage .swiper-container .swiper-slide img {
  width: auto;
  display: block;
  height: 90%;
  max-resolution: 0 auto;
}
</style>
    <style scoped media="screen">
.loginBox {
  width: 100%;
  height: 100%;
  background: url(../assets/images/9.png) center/cover;
  /* background-image: linear-gradient(#00c9ff, #006dcd); */
  position: relative;
}
.titleBox {
  width: 100%;
  margin: 0 auto;
  padding: 15px 0 10px 0;
  background: #fff;
}

.bannerBox {
  width: 1265px;
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 700px;
}
.w-title1 {
  height: 36px;
  margin: 0 20px 0 35px;
}
.w-title2 {
  height: 29px;
}
.login {
  width: 100%;
  height: 700px;
}
.loginBj {
  height: 700px;
  display: flex;
  background: url(../assets/images/hr-login.png) center/cover;
  background-size: 100% 100%;
}

.loginBj .left {
  width: 50%;
  border-radius: 8px 0px 0px 8px;
  overflow: hidden;
  /* margin-left: 3%; */
  float: left;
}

.loginBj .left img {
  width: 100%;
  height: 100%;
}

.loginBj .right {
  width: 50%;
  position: relative;
  border-radius: 0 8px 8px 0px;
  overflow: auto;
}
.loginBj .right::-webkit-scrollbar {
  background: none;
}
.loginBj .right .loginright {
  position: absolute;
  top: 0;
  right: 0;
  width: 300px;
  height: 48px;
}

.loginBj .right .title {
  margin: 0 auto;
  margin-top: 40px;
  margin-bottom: 30px;
  text-align: center;
  font-size: 26px;
  color: #128bf1;
}

.logins {
  width: 80%;
  margin-top: 50px;
  margin-left: 50px;
  display: flex;
  flex-direction: column;
  text-align: left;
}

.box {
  position: relative;
  height: 50px;
}

.box img {
  position: absolute;
  bottom: 25%;
  z-index: 1;
}
.forget {
  margin-top: 20px;
}
.wang {
  display: flex;
}

.wang .shensu {
  text-decoration: underline;
  font-size: 0.18rem;
  line-height: 30px;
  color: #707070;
  cursor: pointer;
}

.logins .buttons {
  display: inline-block;
  width: 160px;
  height: 45px;
  background-color: #128bf1;
  border-radius: 2px;
  color: #fff;
  font-size: 18px;
  position: absolute;
  right: 0;
  bottom: 36%;
  text-align: center;
  line-height: 45px;
  cursor: pointer;
}

.forget {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
}

.dengluSign {
  margin-top: 40px;
  display: flex;
  justify-content: center;
}

.dengluSign .denglu {
  width: 40%;
  height: 50px;
  background-color: #ffffff;
  border: solid 1px #cccccc;
  border-radius: 2px;
  line-height: 50px;
  text-align: center;
  cursor: pointer;
  color: #787878;
  font-size: 20px;
  margin-left: 30px;
}

.dengluSign .denglu:first-child {
  margin-left: 0;
}

.dengluSign .denglu.active {
  border: solid 1px #128bf1;
  background-color: #128bf1;
  color: #fff;
}

/* .shensu {
        width: 40%;
        color: #128bf1;
        font-size: 16px;
        text-decoration: underline;
        text-align: center;
        margin-left: 70%;
        margin-top: 10px;
        cursor: pointer;
    } */

.agreeBox {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1;
}

.agreeBox .agree {
  width: 50%;
  height: 80%;
  background: rgba(0, 0, 0, 0);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}

.agreeBox .agree .agreeTop {
  width: 100%;
  height: 95%;
  border-radius: 10px;
  background: #fff;
  padding: 34px;
  overflow: hidden;
}

.agreeBox .agree .agreeTop .title {
  color: #4c4c4c;
  font-size: 24px;
  text-align: center;
  margin-bottom: 30px;
}

.agreeBox .agree .agreeTop .desc {
  font-size: 16px;
  color: #4c4c4c;
}

.agreeBox .agree .agreeTop .agreeContinue {
  width: 80%;
  height: 50px;
  line-height: 50px;
  font-size: 20px;
  text-align: center;
  color: #fff;
  background: #0372ff;
  margin: 20px auto 0 auto;
}

.agreeBox .agree .agreeBottom {
  width: 60px;
  height: 60px;
  margin: 10px auto 0 auto;
  cursor: pointer;
}
.d1366,
.d1440,
.d1920 {
  display: none;
  margin-top: 5px;
}
.forget .checkBox {
  display: flex;
}
/*分辨率不大于1440，采用下面的样式*/
@media screen and (max-width: 1610px) {
  .d1440 {
    display: block;
  }
  .slide-verify {
    width: 380px !important;
  }
  .bannerBox {
    height: 550px;
    width: 950px;
  }
  .logins {
    margin-top: 35px;
    margin-left: 40px;
  }
  .login {
    height: 100%;
  }
  .loginBj {
    width: 950px;
    height: 500px;
  }
  .loginBj .right .title {
    margin-top: 50px;
    margin-bottom: 80px;
    font-size: 20px;
  }
  .box {
    height: 35px;
  }
  .dengluSign {
    margin-top: 20px;
  }
  .dengluSign .denglu {
    width: 35%;
    height: 35px;
    line-height: 35px;
    font-size: 16px;
  }
  .w-title1 {
    height: 26px;
    margin: 0 15px 0 30px;
  }
  .w-title2 {
    height: 20px;
  }
  .ljj_yunwei {
    font-size: 12px;
  }
}
/*分辨率不小于1920，采用下面的样式*/
@media screen and (min-width: 1610px) and (max-width: 5000px) {
  .d1920 {
    display: block;
  }
  .slide-verify {
    width: 506px !important;
  }
  .ljj_yunwei {
    font-size: 16px;
  }
}
.ljj_yunwei {
  width: 100%;
  color: #000000;
  margin-right: 0.3rem;
  display: flex;
  justify-content: center;
  position: absolute;
  bottom: 0.3rem;
  margin: 0 auto;
  opacity: 0.95;
}
</style>
    <style>
@media screen and (max-width: 1610px) {
  .box .el-input__inner {
    font-size: 14px !important;
    height: 40px !important;
    line-height: 40px !important;
  }
}

input:-internal-autofill-selected {
  -webkit-box-shadow: 0 0 0px 1000px white inset !important;
}
/* .el-message-box__header{
        padding-top: 0;
    } */
input:-webkit-autofill,
textarea:-webkit-autofill,
select:-webkit-autofill {
  -webkit-text-fill-color: #ededed !important;
  -webkit-box-shadow: 0 0 0px 1000px transparent inset !important;
  background-color: transparent;
  background-image: none;
  transition: background-color 50000s ease-in-out 0s;
}
input {
  background-color: transparent;
}

.box .el-input__inner {
  /* border: 0;
        background: transparent;
        border-bottom: 1px solid #cccccc; */
  border: 0;
  border-bottom: 1px solid #dbdbdb;
  background: none;
  border-radius: 0;
  padding-left: 46px;
  font-size: 14px;
  color: #707070;
  padding-top: 10px;
  padding-bottom: 10px;
}
.forget .checkBox .el-checkbox__label {
  color: #707070;
}

/* .slide-verify-slider {
        width: 456px !important;
        border-radius: 20px;
    }

    .slide-verify-slider-mask-item {
        width: 60px !important;
        height: 36px !important;
        border-radius: 20px;
        margin-top: 1px;
    }

    .slide-verify-slider-mask-item-icon {
        left: 23px !important;
    } */
</style>
    <style rel="stylesheet/scss" lang="scss">
.login-code {
  width: 33%;
  height: 38px;
  float: right;
  img {
    cursor: pointer;
    vertical-align: middle;
  }
}
.login-code-img {
  height: 38px;
}
#buttonContainer {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 9999;
}
#backToTopBtn {
  cursor: pointer;
  border: none;
  background-color: transparent;
  padding: 10px;
}
#toggleBtn {
  position: absolute;
  top: -10px;
  right: 0;
  cursor: pointer;
  padding: 0px;
  border-radius: 50%;
}
</style>


<style scoped>
.login_header {
  text-align: center;
  font-size: 15px;
  padding-top: 60px;
  padding-left: 30px;
  /* margin-bottom: -30px; */
}
.login_header span {
  margin-right: 50px;
  cursor: pointer;
}
.active {
  color: #3f7dff;
  padding-bottom: 8px;
  border-bottom: 3px solid #3f7dff;
}
</style>
